import { render } from "./MainPageView.vue?vue&type=template&id=c88b03f2&scoped=true&lang=pug"
import script from "./MainPageView.vue?vue&type=script&lang=js"
export * from "./MainPageView.vue?vue&type=script&lang=js"

import "./MainPageView.vue?vue&type=style&index=0&id=c88b03f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c88b03f2"]])

export default __exports__